import { render, staticRenderFns } from "./ModalDownloadRiwayatStok.vue?vue&type=template&id=2ef2fabd&"
import script from "./ModalDownloadRiwayatStok.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadRiwayatStok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports